import React, { memo } from "react";
import PropTypes from "prop-types";
import { Stack, Button, Icon, Divider } from "investira.react.components";

const PosicoesContextActions = memo((props) => {
  return (
    <Stack justifyContent="center" sx={{ height: "40px" }}>
      <Stack direction="row" alignItems="center">
        <Stack direction="row" spacing={2}>
          <Stack direction="row" spacing={1.5}>
            <Button
              disabled={props.disabled}
              variant="contained"
              color="primary"
              startIcon={<Icon iconName="execute" size={16} />}
              size="small"
              sx={{ px: 2 }}
            >
              Gerar Relatórios
            </Button>
          </Stack>
          <Divider orientation="vertical" flexItem />
          <Button
            disabled={props.disabled}
            variant="contained"
            color="error"
            startIcon={<Icon iconName="delete" size={16} />}
            size="small"
            sx={{ px: 2 }}
          >
            Excluir
          </Button>
        </Stack>
      </Stack>
    </Stack>
  );
});

PosicoesContextActions.propTypes = {
  disabled: PropTypes.bool,
};

export default PosicoesContextActions;
